import "./flash-dismiss"
import React from "react"
import { createRoot } from "react-dom/client"
import { DashboardPage } from "./pages/dashboard-page"
import { ModulePage } from "./pages/module-page"
import { AccountantPage } from "./pages/accountant-page"
import { PurchasesPage } from "./pages/purchases-page"
import { SalesPage } from "./pages/sales-page"
import { CreditNotesPage } from "./pages/credit-notes-page"
import { DocumentsPage } from "./pages/documents-page"
import { TimeTrackingPage } from "./pages/time-tracking-page"
import { ItemsPage } from "./pages/items-page"
import { AdminPage } from "./pages/admin-page"
import { ReportsPage } from "./pages/reports-page"
import { BankingPage } from "./pages/banking-page"
import { EmployeeManagementPage } from "./pages/employee-management-page"
import { LoadersPage } from "./pages/loaders-page"

/* Global styles: Propshaft serves app/assets/builds/application.css (run `npm run build:css`). */
const rootElement = document.getElementById("book-root")

if (rootElement) {
  const page = rootElement.dataset.page
  let props = {}
  if (rootElement.dataset.props) {
    try {
      props = JSON.parse(rootElement.dataset.props)
    } catch (error) {
      console.error("Failed to parse page props", error)
    }
  }
  const root = createRoot(rootElement)

  if (page === "dashboard") {
    root.render(<DashboardPage {...props} />)
  } else if (page === "module") {
    root.render(<ModulePage {...props} />)
  } else if (page === "purchases") {
    root.render(<PurchasesPage {...props} />)
  } else if (page === "sales") {
    root.render(<SalesPage {...props} />)
  } else if (page === "accountant") {
    root.render(<AccountantPage {...props} />)
  } else if (page === "credit-notes") {
    root.render(<CreditNotesPage {...props} />)
  } else if (page === "documents") {
    root.render(<DocumentsPage {...props} />)
  } else if (page === "time-tracking") {
    root.render(<TimeTrackingPage {...props} />)
  } else if (page === "items") {
    root.render(<ItemsPage {...props} />)
  } else if (page === "admin") {
    root.render(<AdminPage {...props} />)
  } else if (page === "reports") {
    root.render(<ReportsPage {...props} />)
  } else if (page === "banking") {
    root.render(<BankingPage {...props} />)
  } else if (page === "employee-management") {
    root.render(<EmployeeManagementPage {...props} />)
  } else if (page === "loaders") {
    root.render(<LoadersPage {...props} />)
  }
}
